// Wraps Meta's fbq snippet so we can boot a PageView fast, then re-init with
// hashed manual advanced matching once we have it.

import type { AMInputs } from '../src/lib/hash';

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
    _fbq?: unknown;
  }
}

const FBQ_LOADER_INSTALLED = '__capi_fbq_installed';

function installFbqLoader(): void {
  const w = window as unknown as Record<string, unknown>;
  if (w[FBQ_LOADER_INSTALLED]) return;
  w[FBQ_LOADER_INSTALLED] = true;

  // Standard Meta Pixel snippet, abbreviated.
  /* eslint-disable */
  // @ts-expect-error vendor snippet
  !function(f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
    if (f.fbq) return;
    n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
    if (!f._fbq) f._fbq = n;
    n.push = n; n.loaded = true; n.version = '2.0'; n.queue = [];
    t = b.createElement(e); t.async = true; t.src = v;
    s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
  }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */
}

export function bootPixel(pixelId: string): void {
  installFbqLoader();
  window.fbq?.('init', pixelId);
  window.fbq?.('track', 'PageView');
}

export function reinitWithAdvancedMatching(pixelId: string, hashedUserData: AMInputs): void {
  installFbqLoader();
  window.fbq?.('init', pixelId, hashedUserData as Record<string, unknown>);
}

export function trackEvent(
  eventName: 'Lead' | 'Purchase',
  customData: Record<string, unknown>,
  eventId: string,
): void {
  installFbqLoader();
  window.fbq?.('track', eventName, customData, { eventID: eventId });
}
